import type { EtapaDto, FunilDto } from '@crm/shared'
import { juntar } from './ui'

/**
 * As etapas do funil em quadradinhos inclinados (ideia de 06/10/2026). Cada
 * um tem a cor da etapa no quadro de Leads; o da etapa atual fica aceso por
 * inteiro, e os outros pela metade, entre o cinza e a cor. Fora do funil,
 * todos ficam num cinza apagado.
 *
 * Aparece no alto da conversa e no card do quadro de Leads. O desenho é um só,
 * e o que o clique faz fica com quem usa: na conversa, mover ou abrir a
 * negociação; no card, mover como se tivesse arrastado.
 */
export function QuadradinhosDoFunil({
  funil,
  etapaAtualId,
  dica,
  aoClicar,
}: {
  funil: FunilDto
  /** `null` é fora do funil: todos em cinza. */
  etapaAtualId: string | null
  dica: (etapa: EtapaDto, atual: boolean) => string
  /** Sem ele, os quadradinhos só mostram. */
  aoClicar?: (etapa: EtapaDto) => void
}) {
  const noFunil = etapaAtualId !== null && funil.etapas.some((e) => e.id === etapaAtualId)

  /*
    Em espaço curto (o alto da conversa no celular), os quadradinhos estreitam até 7px em vez de
    sumirem cortados pela borda: com seis etapas, só as três primeiras apareciam, e as outras ficavam
    escondidas atrás dos botões, sem como clicar.
  */
  return (
    <span className="flex min-w-0 items-center gap-[3px]">
      {funil.etapas.map((etapa) => {
        const atual = noFunil && etapa.id === etapaAtualId
        return (
          <button
            key={etapa.id}
            type="button"
            disabled={!aoClicar}
            onClick={(e) => {
              // O card e o nome em volta abrem outra coisa: o clique aqui é da etapa.
              e.stopPropagation()
              aoClicar?.(etapa)
            }}
            title={dica(etapa, atual)}
            aria-label={`${funil.nome}: ${etapa.nome}${atual ? ' (etapa atual)' : ''}`}
            className={juntar(
              'h-3 w-[18px] min-w-[7px] shrink -skew-x-[20deg] rounded-[2px] transition',
              aoClicar ? 'hover:scale-125' : 'cursor-default',
              noFunil ? null : 'bg-tinta-300 opacity-50',
            )}
            style={
              noFunil
                ? {
                    backgroundColor: etapa.cor,
                    opacity: atual ? 1 : 0.4,
                    filter: atual ? undefined : 'saturate(0.55)',
                  }
                : undefined
            }
          />
        )
      })}
    </span>
  )
}
